import { render } from "./country-settings.vue?vue&type=template&id=49a0fb98"
import script from "./country-settings.vue?vue&type=script&lang=js"
export * from "./country-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__